import { W as WuiTag$1, d as defineCustomElement$1 } from './p-X4ah_kdd.js';

const WuiTag = WuiTag$1;
const defineCustomElement = defineCustomElement$1;

export { WuiTag, defineCustomElement };
